import { WebPortalService } from "../resource";

const MlhgNumberModule = {
  namespaced: true,
  state: {
    data: [],
    number: []
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },
    SET_NUMBER(state, data) {
      state.number = data;
    }
  },
  actions: {
    createData({ commit, state }, data) {
      return WebPortalService.MlhgNumberAdd(data);
    },
    deleteData({ commit, state }, data) {
      return WebPortalService.MlhgNumberDelete(data);
    },
    async listData({ commit, state }, data) {
      try {
        const res = await WebPortalService.MlhgNumberList(data);
        if (res.data.Data == null) {
          commit("SET_DATA", []);
        } else {
          commit("SET_DATA", res.data.Data);
        }
      } catch {
        commit("SET_DATA", []);
      }
    },
    async listCorporateNumber({ commit, state }, data) {
      try {
        const res = await WebPortalService.NumberListByEnterpriseV4(data);
        if (res.data.Data == null) {
          commit("SET_NUMBER", []);
        } else {
          commit("SET_NUMBER", res.data.Data);
        }
      } catch {
        commit("SET_NUMBER", []);
      }
    }

  },
  getters: {
    getData(state) {
      return state.data;
    },
    getNumberByCorporateID(state ){
      return state.number
    },
  }
};

export default MlhgNumberModule;
